import Bugsnag, { type Client, type BrowserConfig } from "@bugsnag/js";
import { decodeJWT, type JwtPayload } from "../public/lib/helpers/jwt";
import { getBugsnagApiKey, getBusgnagStage } from "../constants/provider";

let client: Client | null = null;

export const getClient = () => {
  const stage = getBusgnagStage();

  console.log("The current stage is: ", stage);

  const bugsnagConfig: BrowserConfig = {
    apiKey: getBugsnagApiKey(), // fooji-microsites-v2 api key
    appVersion: import.meta.env.npm_package_version as string,
    releaseStage: stage,
    enabledReleaseStages: ["production"],
    autoDetectErrors: stage !== "test",
    redactedKeys: [
      // User details
      "first_name",
      "last_name",
      "email",
      "phone",
      "business",
      // Address
      "latitude",
      "longitude",
      "address1",
      "address2",
      "state",
      "zip",
      "country",
      "city",
      "place_id"
    ]
  };
  if (!client) {
    client = Bugsnag.createClient(bugsnagConfig);
  }
  return client;
};

// This is only used in tests
export const clearClient = () => {
  client = null;
};

type BugsnagEventMetadata = {
  campaign_key: string;
  response?: Record<string, unknown> | string;
  error?: unknown;
  response_status?: number;
  jwt?: JwtPayload | null;
};

type NotifyPayload = {
  errorMessage: string;
  response?: Response;
  jwt?: string;
  error?: unknown;
  additionalMetadata?: Record<string, unknown>;
  isJsonResponse?: boolean;
};

export const notify = async (payload: NotifyPayload) => {
  const { errorMessage, response, jwt, error, isJsonResponse = true, additionalMetadata } = payload;
  const decodedJWT = jwt ? decodeJWT(jwt) : null;
  const campaignKey = decodedJWT?.fooji_data.campaign_user?.campaign_key ?? "Unknown campaign key";

  const processedResponse = isJsonResponse
    ? await response?.clone().json() as Record<string, unknown>
    : await response?.clone().text();

  console.log("Notifying Bugsnag with error: ", errorMessage);
  getClient().notify(new Error(errorMessage), (event) => {
    const metadata: BugsnagEventMetadata = {
      campaign_key: campaignKey,
      ...additionalMetadata ?? {}
    };

    if (response) {
      metadata.response_status = response.status;
      metadata.response = processedResponse;

      if (response.status === 401) {
        metadata.jwt = decodedJWT;
      }
    }

    if (error) {
      metadata.error = error;
    }

    console.log("Adding metadata to Bugsnag event: ", metadata);

    event.addMetadata("error_details", metadata);
  });
};
